import { render, staticRenderFns } from "./WidgetAccountSwitcher.vue?vue&type=template&id=6adf4578&scoped=true&"
import script from "./WidgetAccountSwitcher.vue?vue&type=script&lang=js&"
export * from "./WidgetAccountSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf4578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6adf4578')) {
      api.createRecord('6adf4578', component.options)
    } else {
      api.reload('6adf4578', component.options)
    }
    module.hot.accept("./WidgetAccountSwitcher.vue?vue&type=template&id=6adf4578&scoped=true&", function () {
      api.rerender('6adf4578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/WidgetAccountSwitcher.vue"
export default component.exports